import { OverlayViewF } from '@react-google-maps/api'
import { rem } from 'polished'
import React, { MouseEventHandler, useCallback, useEffect, useRef, useContext } from 'react'
import styled from 'styled-components'

import PinHeart from './PinAccessory/PinHeart'
import SearchPin from './Pins/SearchPin'
import SelectedMapItemPin from './Pins/SelectedMapItemPin'
import { determineItemType } from '../MapSearch'
import { BaseMapElementComponentProps, pinOffSetter } from '../utils'

import Clickable from 'components/Common/Clickable'
import { ExploreItem } from 'tripPlanner/types/common'
import { itemSectionId } from 'tripPlanner/utils/itemSection'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'

const StyledClickable = styled(Clickable)`
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateX(-50%);
`

const PinHeartContainer = styled.div`
  position: absolute;
  bottom: ${rem(20)};
  left: ${rem(15)};
  z-index: 9999;
`

interface Props extends BaseMapElementComponentProps {
  item: ExploreItem
  saved: boolean
}

function SearchMapMarker({
  active,
  item,
  position,
  zIndex,
  saved,
}: Props) {
  const { onSelectMapItem, onDeselectMapItem } = useContext(TripMapContext)

  const onClick: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault()
      e.stopPropagation()
      if (active) {
        onDeselectMapItem()
      } else {
        onSelectMapItem(itemSectionId(item.id))
      }
    },
    [active, onDeselectMapItem, onSelectMapItem, item.id],
  )

  const ref = useRef<HTMLButtonElement | null>(null)

  useEffect(() => {
    if (ref.current && google?.maps) {
      google.maps.OverlayView.preventMapHitsFrom(ref.current)
    }
  }, [ref])

  return (
    <OverlayViewF
      zIndex={active ? 999 : zIndex}
      position={position}
      css={{ pointerEvents: 'none' }}
      getPixelPositionOffset={pinOffSetter}
      mapPaneName="overlayMouseTarget"
    >
      <StyledClickable onClick={onClick} ref={ref}>
        {saved && !active && (
          <PinHeartContainer>
            <PinHeart />
          </PinHeartContainer>
        )}
        {active && <SelectedMapItemPin text={item.name} />}
        {!active && (
          <SearchPin category={determineItemType(item.types)} saved={saved} />
        )}
      </StyledClickable>
    </OverlayViewF>
  )
}

export default React.memo(SearchMapMarker)
